/** Placeholder blocks while the document is not ready yet — no spinner. */
export function WaveEditorPlaceholder() {
  return (
    <div className="wave-editor-placeholder" role="status" aria-live="polite" aria-busy="true">
      <p className="wave-editor-placeholder-hint">Preparazione documento…</p>
      <div className="wave-skeleton-blocks" aria-hidden="true">
        <div className="wave-skeleton-block wave-skeleton-block--title" />
        <div className="wave-skeleton-block wave-skeleton-block--line" />
        <div className="wave-skeleton-block wave-skeleton-block--line wave-skeleton-block--short" />
        <div className="wave-skeleton-block wave-skeleton-block--line" />
        <div className="wave-skeleton-block wave-skeleton-block--widget" />
      </div>
    </div>
  );
}

type SyncBarProps = {
  label?: string;
};

/** Thin top progress while tail ops / reconcile run — content stays visible underneath. */
export function WaveSyncProgressBar({ label = "Aggiornamento in corso…" }: SyncBarProps) {
  return (
    <div className="wave-sync-progress-wrap" role="status" aria-live="polite">
      <div className="wave-sync-progress" aria-hidden="true">
        <div className="wave-sync-progress__bar" />
      </div>
      <span className="wave-sync-hint">{label}</span>
    </div>
  );
}
